module.exports = function(bh) {
    bh.match('card-actions', function(ctx, json) {
        ctx
            .tParam('ID', ctx.generateId(), true)
            .attr('id', ctx.tParam('ID'));
    });
};
